module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_8017.6e89c3b8.png";